"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toBooleanOrNull = exports.toTrueOrNull = exports.getFirstParamValueOrNull = exports.CatalogBrowserPlacePageLayout = void 0;
const tslib_1 = require("tslib");
const data_catalog_shared_1 = require("@tableau/data-catalog-shared");
const shared_urls_1 = require("@tableau/shared-urls");
const vizportalclient_common_components_1 = require("@tableau/vizportalclient-common-components");
const react_1 = tslib_1.__importDefault(require("react"));
const ErrorListProvider_1 = require("../error/components/ErrorListProvider");
const ErrorToasts_1 = require("../error/components/ErrorToasts");
const RegisterErrorStoreInHost_1 = require("../error/components/RegisterErrorStoreInHost");
const CatalogBrowserCountsQueryWrapper_1 = require("./CatalogBrowserCountsQueryWrapper");
const CatalogBrowserHeader_1 = require("./CatalogBrowserHeader");
const hasActiveWarningParamKey = 'hasActiveWarning';
const isCertifiedParamKey = 'isCertified';
class CatalogBrowserPlacePageLayout extends react_1.default.Component {
    render() {
        const searchParams = textSearchFromLocationSearch(this.props.locationSearch);
        return (react_1.default.createElement(ErrorListProvider_1.ErrorListProvider, { key: this.props.selectedSubplace },
            react_1.default.createElement(RegisterErrorStoreInHost_1.RegisterErrorStoreInHost, { registerErrorStore: this.props.registerErrorStore, unregisterErrorStore: this.props.unregisterErrorStore }),
            react_1.default.createElement(ErrorToasts_1.ErrorToasts, null),
            react_1.default.createElement(CatalogBrowserCountsQueryWrapper_1.CatalogBrowserCountsQueryWrapper, { textSearch: searchParams.search, hasActiveWarning: searchParams.hasActiveWarning, isCertified: searchParams.isCertified, webClientResult: this.props.webClientResult }, ({ databasesCount, filesCount, tablesCount, }) => (react_1.default.createElement(vizportalclient_common_components_1.VerticalFlexContainer, { fillFlexParent: true },
                react_1.default.createElement(CatalogBrowserHeader_1.CatalogBrowserHeader, { databasesCount: databasesCount, filesCount: filesCount, tablesCount: tablesCount, selectedSubplace: this.props.selectedSubplace }),
                this.props.renderExplorerComponent(this.props.locationSearch))))));
    }
}
exports.CatalogBrowserPlacePageLayout = CatalogBrowserPlacePageLayout;
function textSearchFromLocationSearch(locationSearch) {
    const paramValuesMap = (0, data_catalog_shared_1.searchToParamValuesMap)(locationSearch);
    return {
        search: getFirstParamValueOrNull(paramValuesMap[shared_urls_1.CatalogUrlParamKeys.search]),
        hasActiveWarning: toBooleanOrNull(getFirstParamValueOrNull(paramValuesMap[hasActiveWarningParamKey])),
        isCertified: toTrueOrNull(getFirstParamValueOrNull(paramValuesMap[isCertifiedParamKey])),
    };
}
function getFirstParamValueOrNull(values) {
    return values && values.length > 0 ? values[0] : null;
}
exports.getFirstParamValueOrNull = getFirstParamValueOrNull;
// Used for binary filters that can only be "off" or "on"
function toTrueOrNull(value) {
    if (value == null) {
        return null;
    }
    else {
        const lowercaseValue = value.toLowerCase();
        return lowercaseValue === 'true' ? true : null;
    }
}
exports.toTrueOrNull = toTrueOrNull;
// Used for ternary filters that can be "off", "on - true", or "on - false"
function toBooleanOrNull(value) {
    if (value == null) {
        return null;
    }
    else {
        const lowercaseValue = value.toLowerCase();
        return lowercaseValue === 'true' ? true : lowercaseValue === 'false' ? false : null;
    }
}
exports.toBooleanOrNull = toBooleanOrNull;
//# sourceMappingURL=CatalogBrowserPlacePageLayout.js.map